import { ReactQuery } from '@codeleap/query'
import { giphyClient } from '../client'

export const useGIF = ({ id }: {id: string}) => {
  const query = ReactQuery.useQuery({
    queryKey: ['gif', id],
    queryFn: async () => {
      try {
        const response = await giphyClient.gif(id)

        if (response.meta.status !== 200) {
          return null
        }
        return response.data
      } catch (error) {
        return null
      }
    },
    retry: false,
    throwOnError: false,
  })

  return query
}
